import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import Layout from "../shared/Layout";
import CreateAGuide from "../tasks/components/CreateAGuide";
import TaskTile from "../tasks/components/TaskTile";
import CreateATask from "../tasks/components/CreateATask";
import { Task } from "../tasks/models/Task";
import { getGeminiEmbedding } from "../ai/GeminiUtils";
import { useQuery } from "react-query";

const Search: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchText, setSearchText] = useState<string>("");
  const [searching, setSearching] = useState<boolean>(false);
  const [tasks, setTasks] = useState<Task[]>([]);
  const [searchTab, setSearchTab] = useState<string>("related");

  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const queryText = searchParams.get("q");

    console.log("queryText:", queryText);

    setSearchText(queryText || "");
    handleTextSearch(queryText);
  }, [location]);

  const {
    data: relatedSnippets,
    isLoading: loadingRelated,
    error: errorRelated,
  } = useQuery(["related_snippets", "search", searchText], async () => {
    const searchEmbedding = await getGeminiEmbedding(searchText);

    return supabase.rpc("match_tasks", {
      query_embedding: searchEmbedding,
      match_threshold: 0.5,
      match_count: 10,
    });
  });

  const handleTextSearch = async (searchText: string | null) => {
    setSearching(true);
    try {
      let query = supabase.from("tasks").select("*");

      if (searchText) {
        if (searchText.includes("tag:")) {
          const tag = searchText.split(":")[1];
          console.log("tag:", tag);
          query = query.contains("tags", [tag]);
        } else {
          query = query.or(
            `title.ilike.%${searchText}%,description.ilike.%${searchText}%`
          );
        }
      }

      console.log("query:", query);

      const { data, error } = await query.order("created_at", {
        ascending: false,
      });

      console.log("data:", data);

      if (error) {
        console.error("Error searching tasks:", error);
      } else {
        setTasks(data as Task[]);
      }

      setSearching(false);
    } catch (error) {
      console.error("Error searching tasks:", error);
      setSearching(false);
    }
  };

  return (
    <Layout>
      <div className="py-8 justify-start flex flex-col items-start">
        <div className="flex w-full px-4 items-center">
          <h2 className="text-2xl font-bold grow">Search Results</h2>
          <CreateATask />
        </div>
      </div>
      <div
        role="tablist"
        className="tabs tabs-lifted w-fit"
      >
        <a
          role="tab"
          className={`tab ${searchTab === "related" ? "tab-active" : ""}`}
          onClick={() => setSearchTab("related")}
        >
          Related
        </a>
        <a
          role="tab"
          className={`tab ${searchTab === "text-search" ? "tab-active" : ""}`}
          onClick={() => setSearchTab("text-search")}
        >
          Text Search
        </a>
      </div>
      {searchTab === "text-search" && searching && (
        <p className="px-4 md:px-8">
          <div className="loading loading-spinner"></div>
        </p>
      )}
      {!searching && searchTab === "text-search" && tasks.length === 0 && (
        <p className="px-4 md:px-8 py-8">No questions found.</p>
      )}

      {!searching && searchTab === "text-search" && tasks.length > 0 && (
        <div className="space-y-4 mt-2 w-full">
          {tasks.map((task) => (
            <TaskTile
              key={task.id}
              task={task}
            />
          ))}
        </div>
      )}
      {searchTab === "related" &&
        !loadingRelated &&
        relatedSnippets?.data?.length === 0 && (
          <p className="px-4 md:px-8 py-8">No questions found.</p>
        )}
      {searchTab === "related" &&
        !loadingRelated &&
        (relatedSnippets?.data ?? []).length > 0 && (
          <div className="w-full mt-2">
            {relatedSnippets?.data &&
              relatedSnippets?.data.length > 0 &&
              relatedSnippets.data.map((task: Task) => (
                <TaskTile
                  key={task.id}
                  task={task}
                />
              ))}
          </div>
        )}
      {searchTab === "related" && loadingRelated && (
        <p className="px-4 md:px-8">
          <div className="loading loading-spinner"></div>
        </p>
      )}
    </Layout>
  );
};

export default Search;
